import { yup } from '.'

export const fragmentConfigurationSchema = yup.object({
  definedValues: yup.array(),
  type: yup.string, // TOOD: change value type 'number'/'string' depending on this prop
  value: yup
    .mixed()
    .nullable()
    .when('type', (type, schema) => {
      if (type === 'boolean') {
        return schema
      }

      return schema
        .includedIn('definedValues')
        .lessThanContext('upperBoundMin')
        .moreThanContext('lowerBoundMax')
    }),
})

export const fragmentSchema = yup.object({
  configuration: fragmentConfigurationSchema,
})
